<template>
    <div class="header">
        <el-button type="primary" icon="el-icon-s-fold" size="mini" class="collapse" @click="onCollapse"></el-button>
        <template v-if="$root.services.length > 1">
            <div class="menu" v-for="menu in $root.services" :key="menu.id" @click="clickMenu(menu.path)" :class="active === menu.path ? 'active' : ''">
                {{getName(menu)}}
            </div>
        </template>
        <div class="tools">
            <el-dropdown @command="changeLocale">
                <div class="el-dropdown-link">
                    {{$t('语言')}}<i class="el-icon-arrow-down el-icon--right"></i>
                </div>
                <el-dropdown-menu>
                    <el-dropdown-item command="zh">中文</el-dropdown-item>
                    <el-dropdown-item command="en">English</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown @command="handleCommand">
                <div class="el-dropdown-link">
                    {{$root.user.alias}}<i class="el-icon-arrow-down el-icon--right"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="changePass">{{$t('修改密码')}}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-button type="text" @click="$root.logOut"><i class="el-icon-switch-button"></i> {{$t('退出')}}</el-button>
        </div>
        <div class="clear"></div>
    </div>
</template>

<i18n locale="en" lang="yaml">
    "修改密码": "Change Password"
    "语言": "Language"
    "退出": "Sign Out"
</i18n>

<script>
    export default {
        name: "Nav",
        data() {
            return {
                active: location.pathname,
                collapse: false
            }
        },
        methods: {
            onCollapse() {
                this.collapse = !this.collapse;
                this.$emit('on-collapse', this.collapse);
            },
            getName(menu) {
                if (this.$i18n.locale === "en") {
                    return menu['enName'] || menu['name'];
                } else {
                    return menu['name'];
                }
            },
            clickMenu(path) {
                if (!path) {
                    return;
                }

                if (path.indexOf("http") > -1) {
                    this.$axios.get("/sso/forward").then(response => {
                        window.location.href = path + "?code=" + response.data;
                    })
                } else {
                    window.location.href = path;
                }
            },
            handleCommand(command) {
                if (command === "changePass") {
                    window.location.href = "/#/changepass";
                }
            },
            changeLocale(val) {
                localStorage.setItem("local", val);
                this.$router.go(0);
            }
        }
    }
</script>

<style scoped>
    .header .collapse {
        padding: 7px 10px;
        margin-right: 60px;
    }

    .header .menu {
        display: inline-block;
        font-size: 14px;
        color: #909399;
        cursor: pointer;
        padding: 0 15px;
    }

    .header .menu:hover {
        color: #000;
    }

    .header .menu.active {
        color: #000;
        border-bottom: 2px solid #409eff;
        transition: border-color .5s, color .5s;
    }

    .header .tools {
        float: right;
        display: inline-block;
    }

    .header .tools > * {
        margin-left: 15px;
    }
</style>


